export const ROV_VIDEO_EXTENSIONS = ['.mp4', '.mov', '.m4v', '.webm', '.avi', '.mkv', '.mpeg', '.mpg']

export const ROV_VIDEO_DROPZONE_ACCEPT = ['video/*', ...ROV_VIDEO_EXTENSIONS].join(',')

export const isRovVideoFile = (file: Pick<File, 'name' | 'type'>): boolean => {
  if (file.type?.startsWith('video/')) return true
  const name = file.name?.toLowerCase() ?? ''
  return ROV_VIDEO_EXTENSIONS.some(extension => name.endsWith(extension))
}
